export default {
  // Sales Agent Module
  'menu.sales-agent': 'Sales Agent',
  'menu.sales-agent.sales-overview': 'Sales Overview',

  // Sales Overview Page
  'pages.salesAgent.salesOverview.title': 'Sales Overview',
  
  // Statistics Cards
  'pages.salesAgent.salesOverview.totalSales': 'Total Sales Amount',
  'pages.salesAgent.salesOverview.totalUnits': 'Total Units Sold',
  'pages.salesAgent.salesOverview.userRevenue': 'User Revenue Total',
  'pages.salesAgent.salesOverview.profitMargin': 'Profit Inventory (Parking/House)',
  
  // Trend Indicators
  'pages.salesAgent.salesOverview.vsLastMonth': 'vs Last Month',
  'pages.salesAgent.salesOverview.forecast': 'Forecast',
  'pages.salesAgent.salesOverview.returnRate': 'Return Rate',
  'pages.salesAgent.salesOverview.vsLastYear': 'Depletion Cycle',
  
  // Sales Analysis
  'pages.salesAgent.salesOverview.salesAnalysis': 'Sales Analysis',
  'pages.salesAgent.salesOverview.monthlyTrend': 'Monthly Performance Trend',
  'pages.salesAgent.salesOverview.salesAmount': 'Amount (10K)',
  'pages.salesAgent.salesOverview.salesCount': 'Units',
  'pages.salesAgent.salesOverview.businessStructure': 'Business Structure',
  
  // Business Types
  'pages.salesAgent.salesOverview.residential': 'Residential',
  'pages.salesAgent.salesOverview.commercial': 'Commercial',
  'pages.salesAgent.salesOverview.parking': 'Underground Parking',
  
  // Project Monitoring
  'pages.salesAgent.salesOverview.projectMonitoring': 'Project Sales & Inventory Monitoring',
  'pages.salesAgent.salesOverview.projectName': 'Project Name',
  'pages.salesAgent.salesOverview.type': 'Type',
  'pages.salesAgent.salesOverview.totalAmount': 'Sales Amount (10K)',
  'pages.salesAgent.salesOverview.totalCount': 'Total Units',
  'pages.salesAgent.salesOverview.soldReserved': 'Sold/Reserved',
  'pages.salesAgent.salesOverview.inventory': 'Remaining Inventory',
  'pages.salesAgent.salesOverview.depletion': 'Depletion Progress',
  
  // Type Tags
  'pages.salesAgent.salesOverview.type.residential': 'Residential',
  'pages.salesAgent.salesOverview.type.commercial': 'Commercial',
  'pages.salesAgent.salesOverview.type.parking': 'Parking',
  
  // Months
  'pages.salesAgent.salesOverview.month.4': 'Apr',
  'pages.salesAgent.salesOverview.month.5': 'May',
  'pages.salesAgent.salesOverview.month.6': 'Jun',
  'pages.salesAgent.salesOverview.month.7': 'Jul',
  'pages.salesAgent.salesOverview.month.8': 'Aug',
  'pages.salesAgent.salesOverview.month.9': 'Sep',
};
